module.exports = __webpack_public_path__ + "img/Supreme Master First Class.ee2070f5.png";